import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import {
  FroInsightsCoreContextType,
  LiftMetric,
  OptimizedChangeMetric,
} from 'modules/intelligentInsights/frequencyOptimization/types';
import {
  MessageMediumTabs,
  PerformanceOverTimeLift,
} from 'modules/intelligentInsights/frequencyOptimization/types';
import { TimespanEnum } from 'modules/intelligentInsights/types';
import { MessageMedium } from 'constants/messageMediums';

export const defaultContext: FroInsightsCoreContextType = {
  fetchCoreData: noop,
  froInsightsData: {
    messageMediumData: [],
    cardData: {
      largestChangeMedium: MessageMedium.Email,
      largestChangeMetric: OptimizedChangeMetric.OptimizedClickRateChange,
      largestChangeValue: 0,
      largestLiftMedium: MessageMedium.Email,
      largestLiftMetric: LiftMetric.OpenRateLift,
      largestLiftValue: 0,
    },
    messageTypeData: [],
    rawData: [],
    messageMediumByTimeData: [],
  },
  isError: false,
  isLoading: false,
  isReady: true,
  selectedLiftTab: PerformanceOverTimeLift.Open,
  selectedMedium: MessageMediumTabs.Email,
  setSelectedLiftTab: noop,
  setSelectedMedium: noop,
  timeSpan: {
    selectedTimespan: TimespanEnum.Thirty,
    updateTimespan: noop,
  },
};

export const CoreContext = createContext<FroInsightsCoreContextType>(defaultContext);

export const useFroInsightsCoreContext = () => useContext(CoreContext);
